module.exports = __webpack_public_path__ + "img/q4.c52481fc.jpg";